import { is_not } from '@vee-validate/rules'
import { defineRule } from 'vee-validate'

const isNotZero = () => {
  defineRule<number, string[]>('is_not_zero', (value, _target, _ctx: any) => {
    return is_not(value, { other: 0 })
  })
}

export default isNotZero
